<h1 matDialogTitle>{{ helptext.title | translate }}</h1>
<form class="ix-form-container" (submit)="onSubmit()">
  <div [innerHtml]="helptext.message | translate"></div>

  <ix-checkbox
    [formControl]="exportSeedCheckbox"
    [label]="'Export Password Secret Seed' | translate"
  ></ix-checkbox>

  <div [innerHtml]="helptext.warning | translate"></div>

  <ix-form-actions>
    <button mat-button type="button" ixTest="cancel" [matDialogClose]="false">
      {{ helptext.cancelButton | translate }}
    </button>
    <button mat-button type="submit" color="primary" ixTest="save">
      {{ helptext.saveButton | translate }}
    </button>
  </ix-form-actions>
</form>
